import { inject, Injectable } from '@angular/core';
import { Observable, tap, } from 'rxjs';
import { RoleName } from '@sa/app/shared/enums/user-roles';
import { UserAccessService } from '../services/user-access.service';
import { SessionStorageService } from '@sa/app/shared/services/session-storage.service';
import { User } from '../interfaces/User';

@Injectable({ providedIn: 'root' })
export class RoleUtilsService {
    private userAccessService = inject(UserAccessService);
    private _sessionStorageService = inject(SessionStorageService);
    userDetails: User | null = null;

    getUserRoleFeature(): Observable<User | null> {
        return this.userAccessService.getUserRoleFeaturesFromApi().pipe(
            tap(user => {
                if (user) {
                    this._sessionStorageService.setItem('userRoleDetails', JSON.stringify(user));
                }
            })
        );
    }

    private getUser(): User | null {
        return this.userAccessService.getUserRoleFeatures();
    }

    canAuthorizeUser(roleName: string): boolean {
        const user = this.getUser();
        return user ? user.userRole.roleName === roleName : false;
    }
 
    canAddEditDeliverable(roleName: string): boolean {
        const actions: Record<string, () => boolean> = {
            [RoleName.ClientAdmin]: () => {
                return true;
            },
            [RoleName.EYPreparer]: () => {
                return false;
            },
            [RoleName.PlatformAdmin]: () => {
                return false;
            }
        };
        return (actions[roleName] || (() => {
            return false;
        }))();
    }
 
 
    canEditUser(currentUserRole: string, userRole: string): boolean {
 
        const rolePermissions: Record<string, string[]> = {
            [RoleName.EYPreparer]: [RoleName.EYPreparer],
            [RoleName.ClientAdmin]: [RoleName.PlatformAdmin, RoleName.ClientAdmin, RoleName.EYPreparer],
            [RoleName.PlatformAdmin]: [RoleName.PlatformAdmin, RoleName.ClientAdmin, RoleName.EYPreparer],
        };
        const allowedRoles = rolePermissions[currentUserRole];
        if (!allowedRoles) {
            return false;
        }
        const canEdit = allowedRoles.includes(userRole);
        return canEdit;
    }
 
    leftNavigationRule(navigationLabel: string): boolean {
        const user = this.getUser();
        if (!user) return false;
        return user.allowedFeatures.some(f => f.featureName === navigationLabel);
    }

    canReassignUser(assignedTo: string): boolean {
        const user = this.getUser();
        if (!user) return true;
        if (user.userGuid !== assignedTo && user.userRole.roleName === RoleName.EYPreparer)
            return false;
        return true;
    }

    canViewDashboard(): boolean {
        return this.userAccessService.checkUserRoleFeatures(['ViewDashboard']);
    }
}
